import type { TenantConfig } from '@/types/TenantConfig'

const orange = '#EF543F'
const grey = '#222222'
const red = '#f0543f'

export const townhallseattle: TenantConfig = {
  logo: 'assets/townhallseattle/static/logo.png',
  themeOptions: {
    primaryColor: orange,
    secondaryColor: orange,
    logoHeight: '75px',
    headerBackground: red,
    headerHeight: '115px',
    footerBackgroundColor: grey,
    footerTextColor: 'white',
    cartHeaderBackgroundColor: red,
    memberLinksColor: 'white',
    memberLinksColorHover: 'white',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/townhallseattle/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-250px',
      },
    },
  },
}
